import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/Layout"
import Services from "../components/Services"
import HowWeWork from "../components/HowWeWork"
import Portfolio from "../components/Portfolio"
import Technologies from "../components/Technologies"
import Clients from "../components/Clients"
import Reviews from "../components/Reviews"
import Registration from "../components/Registration"
import News from "../components/News"
import HomePageIntro from "../components/HomePageIntro"
import ScrollServices from "../components/ScrollServices"
import BannerCards from "../components/BannerCards"
import OriginStory from "../components/OriginStory"
import { projects } from "../data"

import "../styles/home.scss"
import "../styles/animate.css"
import "../styles/scrollServices.scss"
import "../styles/bannerCards.scss"
import "../styles/clients.scss"
import "../styles/reviews.scss"
import "../styles/originStory.scss"
import "../styles/news.scss"
import "../styles/registration.scss"

const Home = ({ data }) => {
  return (
    <Layout
      className="home-page-intro"
      data={data}
      style={{
        background: `white`,
      }}
      pageTitle={"Visiomate - AI-Native Software Development Company"}
      descrip = {"Streamline your business with our expertise in web & mobile app development and Odoo ERP implementation. We deliver customized solutions for growth of our customers."}
    >
      <HomePageIntro data={data} />
      <OriginStory />
      <ScrollServices data={data} />
      <Clients data={data} />
      <Reviews data={data} />
      <Registration data={data} />
      <News isAbout={false} />
    </Layout>
  )
}

export default Home

export const query = graphql`
  query Images {
    SNGPL: file(relativePath: { eq: "mobile/SNGPLApp-01.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    SBP: file(relativePath: { eq: "mobile/statebankapp.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    EMS: file(relativePath: { eq: "EMS/ems_top_header.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    FarmManagementSystem: file(
      relativePath: { eq: "FarmManagementSystem/pf.jpg" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    SoharPort: file(relativePath: { eq: "soharport 1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    KM: file(relativePath: { eq: "image 5.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    DistributionD365: file(
      relativePath: { eq: "DistributionD365/dist_top_header.png" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    PowerBI: file(relativePath: { eq: "power-BI.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Azure: file(relativePath: { eq: "azure.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    TenderAssetRecordManagement: file(
      relativePath: { eq: "TenderAssetRecordManagement/tender.jpg" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    ViztosPos: file(relativePath: { eq: "ViztosPos/viztos_top_header.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Odoo2: file(relativePath: { eq: "Odoo/odoo.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Custom: file(relativePath: { eq: "Custom/CustDevelopment.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    D365_2: file(relativePath: { eq: "D365/D365_2.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Bigjerry: file(relativePath: { eq: "mobile/BigJerryApp.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    UmrahShuttle: file(relativePath: { eq: "mobile/umrahshuttleapp.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Visioedge: file(relativePath: { eq: "caseStudies/visioedgeheader.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoBlack: file(relativePath: { eq: "logo_black_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoWhite: file(relativePath: { eq: "logo_white_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    arrowImageWhite: file(relativePath: { eq: "Mask group (6).png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    thumbnail: file(relativePath: { eq: "Herosection/herovideostill.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    UMTVisiomate: file(relativePath: { eq: "lifeatvisiomate/UMT_Visiomate3.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    umrahshuttleapp: file(relativePath: { eq: "mobile/umrahshuttleapp.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    viztosForMenu: file(relativePath: { eq: "news/viztos.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    learningcircle: file(relativePath: { eq: "news/learning_circle.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    instagram: file(relativePath: { eq: "instagram.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    facebook: file(relativePath: { eq: "facebook.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    linkedin: file(relativePath: { eq: "linkedin.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    twitter: file(relativePath: { eq: "twitter_bird.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    youtube: file(relativePath: { eq: "youtube.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    arrow: file(relativePath: { eq: "arrow.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    webcaseDiv1: file(relativePath: { eq: "EMS/ems_top_header.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    webcaseDiv2: file(relativePath: { eq: "Custom/Diversepro-1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    mobilecaseDiv1: file(relativePath: { eq: "mobile/umrahshuttleapp.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    mobilecaseDiv2: file(relativePath: { eq: "mobile/BigJerryApp.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    erpcaseDiv1: file(relativePath: { eq: "DistributionD365/dist_top_header.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    erpcaseDiv2: file(relativePath: { eq: "D365/xstackintegration1.webp" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bicaseDiv1: file(relativePath: { eq: "BI/powerbidashboard.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bicaseDiv2: file(relativePath: { eq: "EMS/ems_top_header.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    pseb: file(relativePath: { eq: "logo-pseb 1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Rectangle: file(relativePath: { eq: "Rectangle.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bgImg: file(relativePath: { eq: "Maskgroup4.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
